module.exports = __webpack_public_path__ + "img/RORBPJS40068.7848d3cb.png";